/* __next_internal_client_entry_do_not_use__ default auto */ import * as React from 'react';
import createSvgIcon from "../../utils/createSvgIcon.js";
/**
 * @ignore - internal component.
 */ import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');
